/**
 * Direct deep-link screen for source-document review.
 */
import { escapeHtml } from "./dashboard-html.js";
import type { SourceDocumentReviewFocus } from "./dashboard-lead-factory-types.js";

export function directSourceDocumentReviewId(): string {
  return new URLSearchParams(window.location.search).get("lf_source_document_review")?.trim() ?? "";
}

export async function renderDirectSourceDocumentReview(
  mount: HTMLElement,
  sourceDocumentId: string,
  showReview: (sourceDocumentId: string, statusElement: HTMLElement, focus?: SourceDocumentReviewFocus) => Promise<void>
): Promise<void> {
  mount.innerHTML = `
    <main class="dashboard-shell source-document-review-direct" data-source-document-review-direct>
      <section class="panel">
        <div class="panel-heading">
          <div>
            <h1>Source Document Review</h1>
            <p class="subtle">${escapeHtml(sourceDocumentId)}</p>
          </div>
          <a class="button secondary" href="/">Dashboard</a>
        </div>
        <div id="county-detail" class="detail-drawer open"></div>
        <p id="action-status" class="action-status" role="status" aria-live="polite">Loading source document review...</p>
      </section>
    </main>
  `;
  const statusElement = document.querySelector<HTMLElement>("#action-status");
  if (!statusElement) throw new Error("Missing dashboard element #action-status");
  await showReview(sourceDocumentId, statusElement);
}
